export const MAX_COVER_BYTES = 2 * 1024 * 1024
export const MAX_COVER_DIMENSION = 4096

export function isCaseCoverImage (value) {
  return typeof value === 'string' && value.length <= 4 * Math.ceil(MAX_COVER_BYTES / 3) + 23 && /^data:image\/(png|jpeg);base64,[A-Za-z0-9+/]+={0,2}$/.test(value)
}

export async function readCaseCover (file) {
  if (!file || !['image/png', 'image/jpeg'].includes(file.type)) throw new Error('请选择 JPG 或 PNG 格式的图片。')
  if (!file.size || file.size > MAX_COVER_BYTES) throw new Error('封面图片不能为空，大小不能超过 2MB。')
  const header = new Uint8Array(await file.slice(0, 8).arrayBuffer())
  const png = [137, 80, 78, 71, 13, 10, 26, 10].every((byte, index) => header[index] === byte)
  const jpeg = header[0] === 255 && header[1] === 216 && header[2] === 255
  if (file.type === 'image/png' ? !png : !jpeg) throw new Error('图片格式与实际内容不一致，请重新选择 JPG 或 PNG 图片。')
  const value = await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(new Error('图片读取失败，请重新选择。'))
    reader.onabort = () => reject(new Error('图片读取已取消。'))
    reader.readAsDataURL(file)
  })
  if (!isCaseCoverImage(value)) throw new Error('图片内容无效，请重新选择 JPG 或 PNG 图片。')
  await new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      const valid = image.naturalWidth > 0 && image.naturalHeight > 0 && image.naturalWidth <= MAX_COVER_DIMENSION && image.naturalHeight <= MAX_COVER_DIMENSION
      image.onload = image.onerror = null
      valid ? resolve() : reject(new Error('封面图片的宽和高均不能超过 4096 像素。'))
    }
    image.onerror = () => { image.onload = image.onerror = null; reject(new Error('图片已损坏或无法读取，请重新选择。')) }
    image.src = value
  })
  return value
}
